import React from "react"

import { CheckIcon } from "@atos6/icons"
import { HCenter, Padding, TitleCenter, Paragraph } from "../../ui"

export function OkCell() {
  return (
    <>
      <Padding>
        <HCenter>
          <CheckIcon />
        </HCenter>
      </Padding>
      <TitleCenter>Dados bancários cadastrados com sucesso!</TitleCenter>
      <Paragraph>
        Agora você já pode receber doações através da sua página de doação ou QR
        Code
      </Paragraph>
    </>
  )
}
